import { Field, FieldProps } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';
import { ErrorI18n } from '../error';
import { Help } from '../help';

interface CustomCheckboxProps {
  controlId: string;
  label?: string;
  centered?: boolean;
  className?: string;
  help?: string;
  internal?: boolean;
}

export interface CheckboxProps
  extends
    Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'as' | 'value' | 'checked' | 'title' | 'onChange' | 'onBlur' | 'children'>,
    CustomCheckboxProps {
  isValid?: boolean;
  isInvalid?: boolean;
}

export const Checkbox = ({ controlId, label, centered, className = '', help, ...additionalAttributes }: CheckboxProps) => {
  return (
    <div className={`checkbox${className ? ` ${className}` : ''}`}>
      <Field name={controlId}>
        {({ field, meta }: FieldProps) => (
          <Form.Group controlId={controlId} className={`form-group ${centered ? `d-flex justify-content-center` : ''}`}>
            <div className="form-inline">
              <Form.Check>
                <Form.Check.Input
                  type="checkbox"
                  value={field.value || false}
                  checked={field.value || false}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  isValid={!meta.error && meta.touched}
                  isInvalid={!!meta.error && meta.touched}
                  {...additionalAttributes}
                />
                <Form.Label className={'ms-2'}>
                  {label && <Form.Label>{label}</Form.Label>}
                  {help && <Help placement="top">{help}</Help>}
                </Form.Label>
              </Form.Check>
            </div>
            <ErrorI18n {...meta} />
          </Form.Group>
        )}
      </Field>
    </div>
  );
};
